import './header.scss';

import { CloseOutlined } from '@/media/antd-icons';
import { Bell } from '@/media/icons';
import { LANG_LABELS, SUPPORTED_LANGUAGES } from '@/shared/constants';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ROUTES } from '@/shared/routes';
import { useAppSelector } from '@/store';

const Header: React.FC = () => {
  const { navigate, changeLanguage, currentLang } = useAppNavigate();
  const lang = currentLang.slice(0, 2);

  const { headerConfig, theme } = useAppSelector((state) => state.app);

  if (!headerConfig.showElements.header) return null;

  return (
    <header className="header">
      <div className="header__content">
        {headerConfig.title ? (
          <h1 className="header__title">{headerConfig.title}</h1>
        ) : (
          <img
            src={
              theme === 'dark'
                ? '/assets/logo-white.svg'
                : '/assets/logo-black.svg'
            }
            alt="logo"
            className="header__logo"
          />
        )}

        <div className="header__actions">
          {headerConfig.showElements.langSelector && (
            <div className="header__lang">
              {SUPPORTED_LANGUAGES.map((code) => (
                <button
                  key={code}
                  type="button"
                  className={`header__lang-btn${lang === code ? ' header__lang-btn--active' : ''}`}
                  onClick={() => changeLanguage(code)}
                >
                  {LANG_LABELS[code]}
                </button>
              ))}
            </div>
          )}

          {headerConfig.showElements.notifications && (
            <button
              type="button"
              className="header__bell"
              aria-label="Notifications"
              onClick={() => navigate(`/${ROUTES.notifications}`)}
            >
              <Bell />
            </button>
          )}

          {headerConfig.showElements.closeService && (
            <button
              type="button"
              className="header__close"
              aria-label="Close"
              onClick={() => navigate(`/${ROUTES.home}`)}
            >
              <CloseOutlined />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
